class PlanupdateRequest {
  constructor() {
    this.planId=null;
    this.membershipType=null; 
    this.planTitle=null;
    this.duration =null;
    this.amount =null;
    this.saveOffer =null;
   
  
   

  }}
  export default PlanupdateRequest;